import Container from "./styles";

function SideBackground({ image, className }) {
  return <Container image={image} className={className} />;
}

export default SideBackground;
